import { Injectable } from '@angular/core';

export interface TableState {
    first: number;
    rows: number;
    selectedId: any;
    sortField?: string;
    sortOrder?: number;
}

const STORAGE_PREFIX = 'hr_table_state_';

@Injectable({ providedIn: 'root' })
export class TableStateService {

   
    saveState(key: string, state: TableState): void {
        try {
            sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(state));
        } catch (e) {
        
        }
    }

    getAndClearState(key: string): TableState | null {
        try {
            const raw = sessionStorage.getItem(STORAGE_PREFIX + key);
            if (raw) {
                sessionStorage.removeItem(STORAGE_PREFIX + key);
                return JSON.parse(raw) as TableState;
            }
        } catch (e) {
            
        }
        return null;
    }


    clearState(key: string): void {
        try {
            sessionStorage.removeItem(STORAGE_PREFIX + key);
        } catch (e) {
          
        }
    }
}
